import type { ConnectedDeviceInfo } from '@pyranger/types';

export const getFormattedDeviceInfo = (
    connectedDevice: ConnectedDeviceInfo | null,
) => {
    if (!connectedDevice) {
        return 'No device connected';
    }

    let infoString = '';

    if (connectedDevice.language) {
        infoString += `Language: ${connectedDevice.language}, `;
    }
    if (connectedDevice.version) {
        infoString += `Version: ${connectedDevice.version}, `;
    }
    // if (connectedDevice.board) {
    //     infoString += `Board: ${connectedDevice.board}, `;
    // }
    // if (connectedDevice.frequency) {
    //     infoString += `Frequency: ${connectedDevice.frequency} Hz, `;
    // }
    if (connectedDevice.os_info && connectedDevice.os_info.machine) {
        infoString += `Machine: ${connectedDevice.os_info.machine}, `;
    }

    // Remove the trailing comma and space
    infoString = infoString.replace(/, $/, '');

    return infoString || 'Device connected, but no details available';
};

export const getKnownDeviceLabel = (
    connectedDevice: ConnectedDeviceInfo | null,
) => {
    if (!connectedDevice) {
        return 'Device details unavailable';
    }

    const infoStrings: string[] = [];

    if (connectedDevice.language) {
        if (connectedDevice.os_info.version) {
            infoStrings.push(
                `${connectedDevice.language} ${connectedDevice.os_info.version}`,
            );
        } else {
            infoStrings.push(connectedDevice.language);
        }
    }

    if (connectedDevice.os_info.machine) {
        infoStrings.push(connectedDevice.os_info.machine);
    }

    const cleaned = infoStrings.map((infoString) =>
        infoString.replace(/\([^)]*\)/g, '').trim(),
    );

    const infoString = cleaned.join('; ');

    return (
        // Remove parenthesized details like "(GNU 13.2.0 MinSizeRel)" and trim whitespace
        infoString || 'Device connected, but no details available'
    );
};
